"use strict";
exports.__esModule = true;
exports.forImage = void 0;
function forImage(imageElement) {
    return new Promise(function (resolve, reject) {
        if (imageElement.complete) {
            if (imageElement.naturalHeight === 0) {
                reject(imageElement);
            }
            else {
                resolve();
            }
        }
        imageElement.addEventListener('load', function () {
            resolve();
        });
        imageElement.addEventListener('error', function () {
            reject(new Error("Image \"" + imageElement.src + "\" can not be loaded."));
        });
    });
}
exports.forImage = forImage;
